<mat-sidenav-container autosize hasBackdrop="false" class="sidebar__outer-container">
  <mat-sidenav #sidenav [mode]="'over'" class="sidebar__main-sidenav">
    <ul class="sidebar__items">
      @for (item of items(); track item.name) {
      <li  (mouseenter)="onMouseEnterPrimary(item.name)" (mouseleave)="onMouseLeavePrimary(item)"
        >
        <button class="sidebar__item" [class.sidebar__item_active]="item.name === lastHoveredPrimary()"
        [class.sidebar__item_selected]="item.name === selectedPrimary()" (click)="onClick(item)">
          @if (item.icon) {
            <svg-icon [icon]="item.icon" size="largest"></svg-icon>
          }
          <div class="sidebar__item-label">{{item.label}}</div>
        </button>
      </li>
      }
    </ul>
    <mat-sidenav-container hasBackdrop="false" class="sidebar__inner-container">
      <mat-sidenav #secondarySidenav mode="side" position="start" role="navigation" style="width:fit-content;overflow-x:hidden;" class="sn">
    <ul class="sidebar__items">
      @for (item of secondaryItems(); track item.name) {
      <li>
        @if (item.icon) {
          <svg-icon [icon]="item.icon" size="largest"></svg-icon>
        }
        <button class="sidebar__item sidebar__item_secondary"
          [class.sidebar__item_selected]="item.name === selectedSecondary()" (click)="onClick(item)">
          {{item.label}}
        </button>
      </li>
      }
    </ul>
      </mat-sidenav>
    </mat-sidenav-container>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>